export default __webpack_public_path__ + "static/media/hpLogo.bdcbc32e.png";